import { AstraParagraph } from '~/astra'

type Props = {
    onClick: () => void
    title: string
    subtitle: string
}

export const WaitingListAction = ({ onClick, title, subtitle }: Props) => (
    <span className="flex cursor-pointer items-center hover:underline" onClick={onClick}>
        <AstraParagraph weight="medium" variant="body-small">
            {title}
            <span className="font-hero-regular text-muted"> - {subtitle}</span>
        </AstraParagraph>
    </span>
)
